import Modal from '../../modal.js';

namespace('IO.Views.Components.Rje', function (exports) {
  var ModalSummary = Modal.extend({
    template:
      '<a class="close-modal" href="#">×</a>' +
      '<h3>Last run log summary</h3>' +
      '<p>Last run was on <%= last_run %> and took <%= total_time.toFixed(2) %> seconds.</p>' +
      '<h4>Resources</h4>' +
      '<dl>' +
      '<dt>Total:</dt>' +
      '<dd><%= summary.resources.total %></dd>' +
      '<dt>Changed:</dt>' +
      '<dd><%= summary.resources.changed %></dd>' +
      '<dt>Failed:</dt>' +
      '<dd><%= summary.resources.failed %></dd>' +
      '</dl>' +
      '<% if (logs.err.length || logs.warning.length || logs.notice.length) { %>' +
      '<h4>Logs</h4>' +
      '<ul class="logs">' +
      '<% if (logs.err.length) { %>' +
      '<li>' +
      '<strong>Error:</strong>' +
      '<ul>' +
      '<% _.each(logs.err, function(log) { %>' +
      '<li><%= log %></li>' +
      '<% }); %>' +
      '</ul>' +
      '</li>' +
      '<% } %>' +
      '<% if (logs.notice.length) { %>' +
      '<li>' +
      '<strong>Notice:</strong>' +
      '<ul>' +
      '<% _.each(_.uniq(logs.notice), function(log) { %>' +
      '<li><%= log %></li>' +
      '<% }); %>' +
      '</ul>' +
      '</li>' +
      '<% } %>' +
      '<% if (logs.warning.length) { %>' +
      '<li>' +
      '<strong>Warning:</strong>' +
      '<ul>' +
      '<% _.each(_.uniq(logs.warning), function(log) { %>' +
      '<li><%= log %></li>' +
      '<% }); %>' +
      '</ul>' +
      '</li>' +
      '<% } %>' +
      '</ul>' +
      '<% } %>',

    onInitialization: function () {},

    data: function () {
      if (this.options.data.lastrun) {
        this.options.data.last_run = moment
          .unix(this.options.data.lastrun) // eslint-disable-line camelcase
          .format('MMMM Do YYYY [at] h:mm:ss a');
      }
      return this.options.data || {};
    },

    setData: function (data) {
      if (data) {
        this.options.data = data;
      }
      this._updateContent();
    },

    _updateContent: function () {
      this.setContent(_.template(this.template)(this.data()));
    },

    onRender: function () {
      this._updateContent();
    },
  });

  exports.ModalSummary = ModalSummary;
});
